import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const FoodMenuList = Loadable(
  lazy(() =>
    import("./FoodMasterMenu/FoodMenu").then(({ FoodMenuList }) => ({
      default: FoodMenuList,
    }))
  )
);

const FoodItemsList = Loadable(
  lazy(() =>
    import("./FoodItems/FoodItemsList").then(({ FoodItemsList }) => ({
      default: FoodItemsList,
    }))
  )
);

const FoodCategoryList = Loadable(
  lazy(() =>
    import("./FoodCategory/FoodCategoryList").then(({ FoodCategoryList }) => ({
      default: FoodCategoryList,
    }))
  )
);

const ManageFoodMasterMenu = Loadable(
  lazy(() =>
    import("./FoodMasterMenu/ManageFoodMasterMenu").then(
      ({ ManageFoodMasterMenu }) => ({
        default: ManageFoodMasterMenu,
      })
    )
  )
);

const ImportFoodMenuList = Loadable(
  lazy(() =>
    import("./ImportFoodMenu").then(({ ImportFoodMenuList }) => ({
      default: ImportFoodMenuList,
    }))
  )
);

const ManageImportFoodMenu = Loadable(
  lazy(() =>
    import("./ManageImportFoodMenu").then(({ ManageImportFoodMenu }) => ({
      default: ManageImportFoodMenu,
    }))
  )
);

export const foodMenuRoutes = [
  {
    path: "/master-food-menu",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_MENU]}>
        <FoodMenuList type="master" />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/master-food-menu/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_MENU]}>
        <ManageFoodMasterMenu type="master" />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/master-food-menu/manage/:master_menu_uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_MENU]}>
        <ManageFoodMasterMenu type="master" />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/import-food-menu",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_MENU]}>
        <ImportFoodMenuList />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/import-food-menu/create",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_MENU]}>
        <ManageImportFoodMenu />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/import-food-menu/review/:food_menu_import_uuid",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MASTER_MENU]}>
        <ManageImportFoodMenu />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/food-items",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.FOOD_ITEMS]}>
        <FoodItemsList />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/food-categories",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.FOOD_CATEGORIES]}>
        <FoodCategoryList />
      </AuthorizedRoute>
    ),
  },
];
